const ClearIndicatorStyles = (base, state) => ({
  ...base,
  cursor: "pointer",
  color: "inherit",
  padding: "0",
  margin: "0",
})

export default ClearIndicatorStyles
